<template>
  <div class="center">
    <img src="@/assets/logo-verde.png" class="logo-erro" />
    <h4>Empresa não localizada :(</h4>
  </div>
</template>

<script>
export default {
  name: "Erro"
};
</script>

<style scoped>
.logo-erro {
  width: 35%;
  min-width: 350px;
  padding: 100px 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Erro.vue